import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

export function useObjectUrl(initial: string): [string, Dispatch<SetStateAction<Blob | MediaSource | null>>] {
  const [object, setObject] = useState<Blob | MediaSource | null>(null);
  const [url, setUrl] = useState(initial);
  useEffect(() => {
    if (!object) return undefined;
    const url = URL.createObjectURL(object);
    setUrl(url); // oxlint-disable-line set-state-in-effect
    return () => URL.revokeObjectURL(url);
  }, [object]);
  return [url, setObject];
}
